import React, { Component } from "react";
import Fade from "react-reveal";

class About extends Component {
  render() {
    if (!this.props.data) return null;

    const profilepic = "images/" + this.props.data.image;
	const paypal = "images/paypal-service.png"; 
    const bio = this.props.data.bio;
    const message = this.props.data.message;
    const email = this.props.data.email;


    return (
      <section id="about">
        <Fade duration={1000}>
          <div className="row">
            <div className="four columns">
              <h1>
              <img
                className="profile-pic"
                src={profilepic}
                alt="Tectyte"
              /> Tectyte</h1>
            </div>
            <div className="nine columns main-col">
              <h2>About</h2>

              <h3>{bio}</h3>
              <h2>{message}</h2>
              <div className="row">
                
                <div className="columns download">
                  <p>
                    <a href={email} className="button">
                        <i className="fa fa-envelope"></i>Contact
                    </a>
                  </p>
				  <p>
				  <img
                className="qr-pic"
                src={paypal}
                alt="Pay Tectyte Service" 
              />
				  </p>
                </div>
              </div>
            </div>
          </div>
        </Fade>
      </section>
    );
  }
}

export default About;
